
    const original = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?>\n<svg width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <title>Stage Size</title>\n    <g id=\"stage-size\" stroke=\"#855CD6\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" fill=\"none\">\n        <rect x=\"3.5\" y=\"3.5\" width=\"13\" height=\"13\" rx=\"1.5\"/>\n        <path d=\"M3.5 1.5 L3.5 3.5 L1.5 3.5\"/>\n        <path d=\"M16.5 1.5 L16.5 3.5 L18.5 3.5\"/>\n        <path d=\"M3.5 18.5 L3.5 16.5 L1.5 16.5\"/>\n        <path d=\"M16.5 18.5 L16.5 16.5 L18.5 16.5\"/>\n    </g>\n</svg>\n";

    const getSRC = () => {
        const recolored = typeof Recolor === 'object' ? (
            original.replace(/#855cd6/gi, Recolor.primary)
        ) : original;
        return 'data:image/svg+xml;,' + encodeURIComponent(recolored);
    };

    export default getSRC;
